import { Module, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioGridExt } from '@/classes/scenario/grid/ScenarioGridExt';
import { GridCurveExt } from '@/classes/scenario/grid/GridCurveExt';

const getDefaultFields = () => {

  const defaultStepMinutes = 60;

  const defaultFields = new ScenarioGridExt();

  const defaultCurveBefore = new GridCurveExt();
  defaultCurveBefore.stepMinutes = defaultStepMinutes;

  const defaultCurveAfter = new GridCurveExt();
  defaultCurveAfter.stepMinutes = defaultStepMinutes;

  defaultFields.calculatedCurveBefore = defaultCurveBefore;
  defaultFields.calculatedCurveAfter = defaultCurveAfter;

  return defaultFields;
};

@Module({
  namespaced: true
})
class GridModule extends VuexModule {

  get getConfig(): ScenarioExt {
    return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
  }

  get getFields(): ScenarioGridExt {
    return this.getConfig.grid ? new ScenarioGridExt(this.getConfig.grid) : getDefaultFields();
  }
}

export default GridModule;
